$( ".js-nav-control" ).click(function() {
 	$('body').toggleClass('open');
  	$('.hamburger').toggleClass('isActive ');
});


// Smooth Scroll Animation
	var scroll = new SmoothScroll('a[href*="#"]');
	

	// QTY Adjust
  
	/* JS Quantity Incrementers */
    
	jQuery(function(){
	  var j = jQuery; 
	  var addInput = '.js-qty-wrap'; 
  
	  j(addInput).each(function() { 
	    var inputEl = j(this).closest(addInput).find('input');
	    var n = inputEl.val(); 
	    var plusEl = j(this).closest(addInput).find('.plus');
	    var minEl = j(this).closest(addInput).find('.min');
	    //On plus click add 1 to n
	    plusEl.on('click', function(){
          var cnitem = parseInt(j(".js-go-cart-counter.go-cart-counter").text());
          inputEl.val(++n);
          j(".multi-items input.quantity-selector").each(function() { 
            var item = j(this).val();
            cnitem = cnitem+parseInt(item);
          }); 
          j(".discount-steps .discount-step").removeClass("active");
          j(".discount-ship-text.discount-section").removeClass("active");
          j(".discount-progress-meter .js-progress-visual").css("width", "0%");
          if(cnitem>=3){
            j(".discount-ship-text.discount-section").addClass("active");
            j(".discount-steps .discount-step.step-1").addClass("active");
            j(".js-discount-value .discount-value").text("15");
            j(".discount-steps .discount-step.js-step-2").addClass("active");
            j(".discount-progress-meter .js-progress-visual").css("width", "37%");
          }
          if(cnitem>=6){
            j(".js-discount-value .discount-value").text("25");
            j(".discount-steps .discount-step.js-step-3").addClass("active");
            j(".discount-progress-meter .js-progress-visual").css("width", "62%");
          }
          if(cnitem>=10){
            j(".js-discount-value .discount-value").text("30");
            j(".discount-steps .discount-step.js-step-4").addClass("active");
            j(".discount-progress-meter .js-progress-visual").css("width", "100%");
          }
	    });
	    //On min click 
	    minEl.on('click', function(){
          var cnitem = parseInt(j(".js-go-cart-counter.go-cart-counter").text());
    	  //If n is bigger or equal to 1 subtract 1 from n 
	      if ( ( inputEl.val() ) >= 1) {
	        inputEl.val(--n);
            j(".multi-items input.quantity-selector").each(function() { 
              var item = j(this).val();
              cnitem = cnitem+parseInt(item);
            });
            j(".discount-steps .discount-step").removeClass("active");
            j(".discount-ship-text.discount-section").removeClass("active");
            j(".discount-progress-meter .js-progress-visual").css("width", "0%");
            if(cnitem>=3){
              j(".discount-ship-text.discount-section").addClass("active");
              j(".discount-steps .discount-step.step-1").addClass("active");
              j(".discount-steps .discount-step.js-step-2").addClass("active");
              j(".js-discount-value .discount-value").text("15");
              j(".discount-progress-meter .js-progress-visual").css("width", "37%");
            }
            if(cnitem>=6){
              j(".discount-steps .discount-step.js-step-3").addClass("active");
              j(".js-discount-value .discount-value").text("25");
              j(".discount-progress-meter .js-progress-visual").css("width", "62%");
            }
            if(cnitem>=10){
              j(".discount-steps .discount-step.js-step-4").addClass("active");
              j(".js-discount-value .discount-value").text("30");
              j(".discount-progress-meter .js-progress-visual").css("width", "100%");
            }
	      } 
	    });
	  });
	});
	

// CHANGE IMAGE WITH VARIANT CHANGE
(function(window, $) {
  $(document).ready(function() { 
    $('body')
    .on('change', '#productSelect', function(event) { 
      // Update Price
      var selected     = this.options[this.selectedIndex],
          variantPrice = selected.dataset.price;

      $('#productPrice').text(variantPrice);

      /** Update image Slider */
      var variantImage = selected.dataset.image;
      var position = -1;

      $('.product-thumbs .single-thumb').each(function() { 
        if ( $(this).data('image') == variantImage ) { 
          position = parseInt($(this).data('slick-index'));
          return;
        }
      });

      if ( position != -1 ) { 
        $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
      }


      /** Update Nutritions table tab content */
      if ( this.options.length > 1 && window.product_variants !== undefined ) { 
        product_variants.forEach((variant_meta) => { 
          if ( variant_meta.id == selected.value ) { 
            for (const [key, value] of Object.entries(variant_meta)) { 
              $(`.js-meta-${key}`).empty().html(value);
            }
          }
        });
      }
    })
  })
})(window, jQuery);


// Footer Nav
function resizeHandler() {
  console.log("window resized");

  if ($(window).width() < 767) {
    console.log("window small than 600");
    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
 }
resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});

/* flyout handlers */

function toggleFlyout(element) {
  // console.error(element);

	if (element) {
    element.classList.toggle("open");
	}
}
function responseToDOM(str) {
  return document.createRange().createContextualFragment(str);
}

document.addEventListener("DOMContentLoaded",event=>{
  document.querySelectorAll("[data-toggle-flyout]").forEach(toggler=>{
	var id = toggler.getAttribute("data-flyout-id");
	var flyout = document.querySelector(`.ajax-side-flyout#${id}`);
	if (!flyout) { return; }
	toggler.addEventListener("click",(event)=>{
		toggleFlyout(flyout);
	});
  });
});

